module.exports = __webpack_public_path__ + "img/add-flight-icon.bd641e8b.svg";